// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BusinessRouteImport } from './routes/business'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedChartsRouteImport } from './routes/_authenticated/charts'
import { Route as AuthenticatedHabitsRouteImport } from './routes/_authenticated/habits'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedNotesRouteImport } from './routes/_authenticated/notes'
import { Route as AuthenticatedOverviewRouteImport } from './routes/_authenticated/overview'
import { Route as AuthenticatedPerformanceRouteImport } from './routes/_authenticated/performance'
import { Route as AuthenticatedPillarsRouteImport } from './routes/_authenticated/pillars'
import { Route as AuthenticatedStatusRouteImport } from './routes/_authenticated/status'
import { Route as AuthenticatedTeamRouteImport } from './routes/_authenticated/team'
import { Route as AuthenticatedTimelineExampleRouteImport } from './routes/_authenticated/timeline-example'
import { Route as AuthenticatedWorkRouteImport } from './routes/_authenticated/work'
import { Route as AuthenticatedAssistantIndexRouteImport } from './routes/_authenticated/assistant.index'
import { Route as AuthenticatedAssistantThreadIdRouteImport } from './routes/_authenticated/assistant.$threadId'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports.index'
import { Route as AuthenticatedReportsIdRouteImport } from './routes/_authenticated/reports.$id'
import { Route as AuthenticatedSalesIndexRouteImport } from './routes/_authenticated/sales.index'
import { Route as AuthenticatedSalesAccountsRouteImport } from './routes/_authenticated/sales.accounts'
import { Route as AuthenticatedSalesCalendarRouteImport } from './routes/_authenticated/sales.calendar'
import { Route as AuthenticatedSalesContactsRouteImport } from './routes/_authenticated/sales.contacts'
import { Route as AuthenticatedSalesContractsRouteImport } from './routes/_authenticated/sales.contracts'
import { Route as AuthenticatedSalesCustomerHoursRouteImport } from './routes/_authenticated/sales.customer-hours'
import { Route as AuthenticatedSalesCustomerMeetingsRouteImport } from './routes/_authenticated/sales.customer-meetings'
import { Route as AuthenticatedSalesCustomerTasksRouteImport } from './routes/_authenticated/sales.customer-tasks'
import { Route as AuthenticatedSalesEngagementRouteImport } from './routes/_authenticated/sales.engagement'
import { Route as AuthenticatedSalesForecastRouteImport } from './routes/_authenticated/sales.forecast'
import { Route as AuthenticatedSalesImportRouteImport } from './routes/_authenticated/sales.import'
import { Route as AuthenticatedSalesInboxRouteImport } from './routes/_authenticated/sales.inbox'
import { Route as AuthenticatedSalesOpportunitiesRouteImport } from './routes/_authenticated/sales.opportunities'
import { Route as AuthenticatedSalesPipelineRouteImport } from './routes/_authenticated/sales.pipeline'
import { Route as AuthenticatedSalesRenewalsRouteImport } from './routes/_authenticated/sales.renewals'
import { Route as AuthenticatedSalesRevenuePlanRouteImport } from './routes/_authenticated/sales.revenue-plan'
import { Route as AuthenticatedSalesSettingsRouteImport } from './routes/_authenticated/sales.settings'
import { Route as AuthenticatedVisualsIndexRouteImport } from './routes/_authenticated/visuals.index'
import { Route as AuthenticatedVisualsIdRouteImport } from './routes/_authenticated/visuals.$id'
import { Route as AuthenticatedVisualsBusinessCaseRouteImport } from './routes/_authenticated/visuals.business-case'
import { Route as AuthenticatedVisualsPriceBookRouteImport } from './routes/_authenticated/visuals.price-book'
import { Route as AuthenticatedWorkIndexRouteImport } from './routes/_authenticated/work.index'
import { Route as AuthenticatedWorkRegularMeetingsRouteImport } from './routes/_authenticated/work.regular-meetings'
import { Route as AuthenticatedWorkTimelineRouteImport } from './routes/_authenticated/work.timeline'
import { Route as AuthenticatedSalesAdminImportHistoryRouteImport } from './routes/_authenticated/sales.admin.import-history'
import { Route as AuthenticatedSalesAdminImportHubspotRouteImport } from './routes/_authenticated/sales.admin.import-hubspot'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BusinessRoute = BusinessRouteImport.update({
            id: '/business',path: '/business',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedChartsRoute = AuthenticatedChartsRouteImport.update({
            id: '/charts',path: '/charts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHabitsRoute = AuthenticatedHabitsRouteImport.update({
            id: '/habits',path: '/habits',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotesRoute = AuthenticatedNotesRouteImport.update({
            id: '/notes',path: '/notes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOverviewRoute = AuthenticatedOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPerformanceRoute = AuthenticatedPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPillarsRoute = AuthenticatedPillarsRouteImport.update({
            id: '/pillars',path: '/pillars',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedStatusRoute = AuthenticatedStatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTeamRoute = AuthenticatedTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTimelineExampleRoute = AuthenticatedTimelineExampleRouteImport.update({
            id: '/timeline-example',path: '/timeline-example',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWorkRoute = AuthenticatedWorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAssistantIndexRoute = AuthenticatedAssistantIndexRouteImport.update({
            id: '/assistant/',path: '/assistant/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAssistantThreadIdRoute = AuthenticatedAssistantThreadIdRouteImport.update({
            id: '/assistant/$threadId',path: '/assistant/$threadId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedReportsIndexRoute = AuthenticatedReportsIndexRouteImport.update({
            id: '/reports/',path: '/reports/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedReportsIdRoute = AuthenticatedReportsIdRouteImport.update({
            id: '/reports/$id',path: '/reports/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesIndexRoute = AuthenticatedSalesIndexRouteImport.update({
            id: '/sales/',path: '/sales/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesAccountsRoute = AuthenticatedSalesAccountsRouteImport.update({
            id: '/sales/accounts',path: '/sales/accounts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesCalendarRoute = AuthenticatedSalesCalendarRouteImport.update({
            id: '/sales/calendar',path: '/sales/calendar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesContactsRoute = AuthenticatedSalesContactsRouteImport.update({
            id: '/sales/contacts',path: '/sales/contacts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesContractsRoute = AuthenticatedSalesContractsRouteImport.update({
            id: '/sales/contracts',path: '/sales/contracts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesCustomerHoursRoute = AuthenticatedSalesCustomerHoursRouteImport.update({
            id: '/sales/customer-hours',path: '/sales/customer-hours',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesCustomerMeetingsRoute = AuthenticatedSalesCustomerMeetingsRouteImport.update({
            id: '/sales/customer-meetings',path: '/sales/customer-meetings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesCustomerTasksRoute = AuthenticatedSalesCustomerTasksRouteImport.update({
            id: '/sales/customer-tasks',path: '/sales/customer-tasks',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesEngagementRoute = AuthenticatedSalesEngagementRouteImport.update({
            id: '/sales/engagement',path: '/sales/engagement',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesForecastRoute = AuthenticatedSalesForecastRouteImport.update({
            id: '/sales/forecast',path: '/sales/forecast',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesImportRoute = AuthenticatedSalesImportRouteImport.update({
            id: '/sales/import',path: '/sales/import',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesInboxRoute = AuthenticatedSalesInboxRouteImport.update({
            id: '/sales/inbox',path: '/sales/inbox',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesOpportunitiesRoute = AuthenticatedSalesOpportunitiesRouteImport.update({
            id: '/sales/opportunities',path: '/sales/opportunities',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesPipelineRoute = AuthenticatedSalesPipelineRouteImport.update({
            id: '/sales/pipeline',path: '/sales/pipeline',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesRenewalsRoute = AuthenticatedSalesRenewalsRouteImport.update({
            id: '/sales/renewals',path: '/sales/renewals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesRevenuePlanRoute = AuthenticatedSalesRevenuePlanRouteImport.update({
            id: '/sales/revenue-plan',path: '/sales/revenue-plan',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesSettingsRoute = AuthenticatedSalesSettingsRouteImport.update({
            id: '/sales/settings',path: '/sales/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVisualsIndexRoute = AuthenticatedVisualsIndexRouteImport.update({
            id: '/visuals/',path: '/visuals/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVisualsIdRoute = AuthenticatedVisualsIdRouteImport.update({
            id: '/visuals/$id',path: '/visuals/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVisualsBusinessCaseRoute = AuthenticatedVisualsBusinessCaseRouteImport.update({
            id: '/visuals/business-case',path: '/visuals/business-case',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedVisualsPriceBookRoute = AuthenticatedVisualsPriceBookRouteImport.update({
            id: '/visuals/price-book',path: '/visuals/price-book',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWorkIndexRoute = AuthenticatedWorkIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedWorkRoute
          })
const AuthenticatedWorkRegularMeetingsRoute = AuthenticatedWorkRegularMeetingsRouteImport.update({
            id: '/regular-meetings',path: '/regular-meetings',getParentRoute: () => AuthenticatedWorkRoute
          })
const AuthenticatedWorkTimelineRoute = AuthenticatedWorkTimelineRouteImport.update({
            id: '/timeline',path: '/timeline',getParentRoute: () => AuthenticatedWorkRoute
          })
const AuthenticatedSalesAdminImportHistoryRoute = AuthenticatedSalesAdminImportHistoryRouteImport.update({
            id: '/sales/admin/import-history',path: '/sales/admin/import-history',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalesAdminImportHubspotRoute = AuthenticatedSalesAdminImportHubspotRouteImport.update({
            id: '/sales/admin/import-hubspot',path: '/sales/admin/import-hubspot',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedWorkRouteChildren = {
  AuthenticatedWorkRegularMeetingsRoute: AuthenticatedWorkRegularMeetingsRoute,AuthenticatedWorkTimelineRoute: AuthenticatedWorkTimelineRoute,AuthenticatedWorkIndexRoute: AuthenticatedWorkIndexRoute
}

const AuthenticatedWorkRouteWithChildren = AuthenticatedWorkRoute._addFileChildren(AuthenticatedWorkRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedChartsRoute: AuthenticatedChartsRoute,AuthenticatedHabitsRoute: AuthenticatedHabitsRoute,AuthenticatedInboxRoute: AuthenticatedInboxRoute,AuthenticatedNotesRoute: AuthenticatedNotesRoute,AuthenticatedOverviewRoute: AuthenticatedOverviewRoute,AuthenticatedPerformanceRoute: AuthenticatedPerformanceRoute,AuthenticatedPillarsRoute: AuthenticatedPillarsRoute,AuthenticatedStatusRoute: AuthenticatedStatusRoute,AuthenticatedTeamRoute: AuthenticatedTeamRoute,AuthenticatedTimelineExampleRoute: AuthenticatedTimelineExampleRoute,AuthenticatedWorkRoute: AuthenticatedWorkRouteWithChildren,AuthenticatedAssistantThreadIdRoute: AuthenticatedAssistantThreadIdRoute,AuthenticatedReportsIdRoute: AuthenticatedReportsIdRoute,AuthenticatedSalesAccountsRoute: AuthenticatedSalesAccountsRoute,AuthenticatedSalesCalendarRoute: AuthenticatedSalesCalendarRoute,AuthenticatedSalesContactsRoute: AuthenticatedSalesContactsRoute,AuthenticatedSalesContractsRoute: AuthenticatedSalesContractsRoute,AuthenticatedSalesCustomerHoursRoute: AuthenticatedSalesCustomerHoursRoute,AuthenticatedSalesCustomerMeetingsRoute: AuthenticatedSalesCustomerMeetingsRoute,AuthenticatedSalesCustomerTasksRoute: AuthenticatedSalesCustomerTasksRoute,AuthenticatedSalesEngagementRoute: AuthenticatedSalesEngagementRoute,AuthenticatedSalesForecastRoute: AuthenticatedSalesForecastRoute,AuthenticatedSalesImportRoute: AuthenticatedSalesImportRoute,AuthenticatedSalesInboxRoute: AuthenticatedSalesInboxRoute,AuthenticatedSalesOpportunitiesRoute: AuthenticatedSalesOpportunitiesRoute,AuthenticatedSalesPipelineRoute: AuthenticatedSalesPipelineRoute,AuthenticatedSalesRenewalsRoute: AuthenticatedSalesRenewalsRoute,AuthenticatedSalesRevenuePlanRoute: AuthenticatedSalesRevenuePlanRoute,AuthenticatedSalesSettingsRoute: AuthenticatedSalesSettingsRoute,AuthenticatedVisualsIdRoute: AuthenticatedVisualsIdRoute,AuthenticatedVisualsBusinessCaseRoute: AuthenticatedVisualsBusinessCaseRoute,AuthenticatedVisualsPriceBookRoute: AuthenticatedVisualsPriceBookRoute,AuthenticatedAssistantIndexRoute: AuthenticatedAssistantIndexRoute,AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,AuthenticatedSalesIndexRoute: AuthenticatedSalesIndexRoute,AuthenticatedVisualsIndexRoute: AuthenticatedVisualsIndexRoute,AuthenticatedSalesAdminImportHistoryRoute: AuthenticatedSalesAdminImportHistoryRoute,AuthenticatedSalesAdminImportHubspotRoute: AuthenticatedSalesAdminImportHubspotRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,BusinessRoute: BusinessRoute,HowItWorksRoute: HowItWorksRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)